export enum EnrollmentAgentType {
    Agent = 1,
    CallCenter = 2
}